import Youtube from "react-youtube";
import * as React from 'react';
export default {
  Youtube,
  React
};